import { render, staticRenderFns } from "./editDetails.vue?vue&type=template&id=55387ab6"
import script from "./editDetails.vue?vue&type=script&lang=js"
export * from "./editDetails.vue?vue&type=script&lang=js"
import style0 from "./editDetails.vue?vue&type=style&index=0&id=55387ab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports